<div>
  <div>
    <div>
      <div style="text-align: center; margin: auto; font-size: medium" *ngIf="!isAtHome && mobile">
        <div class="card-title"><b>Live Portfolio</b></div>
        This is our live portfolio, and will update frequently
        <span class="card-text" class="table table-striped" style="    display: flex;
          flex-wrap: wrap;
          justify-content: center;">
          <div class="portfolioTab">
            <thead>
              <tr>
                <th class="portHeading">Name</th>
                <th class="portHeading">Invested</th>
                <th class="portHeading" *ngIf="!mobile">Investment %</th>
                <th class="portHeading" *ngIf="!mobile">Open Rate</th>
                <!-- <th class="portHeading" *ngIf="mobile">Open</th> -->
                <th class="portHeading">P/L($)</th>
                <th class="portHeading" *ngIf="!mobile">Net Profit %</th>
                <th class="portHeading" *ngIf="mobile">%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let position of portfolioPositions">
                <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                <td class="portHeading portLeft">${{position.invested}}</td>
                <td class="portHeading" *ngIf="!mobile">{{position.investmentPct}}%</td>
                <td class="portHeading" *ngIf="!mobile">{{position.openRate}}</td>
                <td class="portHeading" *ngIf="position.lossOrGain" style="color: green"><b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="!position.lossOrGain" style="color: #EE4B2B">-<b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="position.negOrPos" style="color: green; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
                <td class="portHeading" *ngIf="!position.negOrPos" style="color: #EE4B2B; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left;">
                  <b>Current MTD - Gain / Loss Rate</b>
                </td>
                <td style="text-align: right;">
                  <b>Total</b>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: right;">
                  <span class="portHeading" *ngIf="netGain >= 0"
                    style="color: green; text-align: right;"><b>{{netGain}}%</b></span>
                  <span class="portHeading" *ngIf="netGain < 0"
                    style="color: #EE4B2B; text-align: right;"><b>{{netGain}}%</b></span>
                </td>
              </tr>
            </tbody>
          </div>

        </span>
      </div>
      <div style="text-align: center; margin: auto; font-size: large" *ngIf="!mobile">
        <div class="card-title"><b>Live Portfolio</b></div>
        This is our live portfolio, and will update frequently
        <span class="card-text" class="table table-striped" style="    display: flex;
          flex-wrap: wrap;
          justify-content: center;">
          <div class="portfolioTab">
            <thead>
              <tr>
                <th class="portHeading">Name</th>
                <th class="portHeading">Invested</th>
                <th class="portHeading" *ngIf="!mobile">Investment %</th>
                <th class="portHeading" *ngIf="!mobile">Open Rate</th>
                <!-- <th class="portHeading" *ngIf="mobile">Open</th> -->
                <th class="portHeading">P/L($)</th>
                <th class="portHeading" *ngIf="!mobile">Net Profit %</th>
                <th class="portHeading" *ngIf="mobile">%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let position of portfolioPositions">
                <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                <td class="portHeading portLeft">${{position.invested}}</td>
                <td class="portHeading" *ngIf="!mobile">{{position.investmentPct}}%</td>
                <td class="portHeading" *ngIf="!mobile">{{position.openRate}}</td>
                <td class="portHeading" *ngIf="position.lossOrGain" style="color: green"><b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="!position.lossOrGain" style="color: #EE4B2B">-<b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="position.negOrPos" style="color: green; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
                <td class="portHeading" *ngIf="!position.negOrPos" style="color: #EE4B2B; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
              </tr>
              <tr>
                <td colspan="5" style="text-align: left;">
                  <b>Current MTD - Gain / Loss Rate</b>
                </td>
                <td style="text-align: right;">
                  <b>Total</b>
                </td>
              </tr>
              <tr>
                <td colspan="6" style="text-align: right;">
                  <span class="portHeading" *ngIf="netGain >= 0"
                    style="color: green; text-align: right;"><b>{{netGain}}%</b></span>
                  <span class="portHeading" *ngIf="netGain < 0"
                    style="color: #EE4B2B; text-align: right;"><b>{{netGain}}%</b></span>
                </td>
              </tr>
            </tbody>
          </div>
        </span>
      </div>
      <div style="text-align: center; margin: auto; font-size: medium" *ngIf="isAtHome && mobile">
        <div class="card-title"><b>Live Portfolio</b></div>
        This is our live portfolio, and will update frequently
        <span class="card-text" class="table table-striped" style="    display: flex;
          flex-wrap: wrap;
          justify-content: center;">
          <div class="portfolioTab">
            <thead>
              <tr>
                <th class="portHeading">Name</th>
                <th class="portHeading">Invested</th>
                <th class="portHeading" *ngIf="!mobile">Investment %</th>
                <th class="portHeading" *ngIf="!mobile">Open Rate</th>
                <!-- <th class="portHeading" *ngIf="mobile">Open</th> -->
                <th class="portHeading">P/L($)</th>
                <th class="portHeading" *ngIf="!mobile">Net Profit %</th>
                <th class="portHeading" *ngIf="mobile">%</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let position of portfolioPositions">
                <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                <td class="portHeading portLeft">${{position.invested}}</td>
                <td class="portHeading" *ngIf="!mobile">{{position.investmentPct}}%</td>
                <td class="portHeading" *ngIf="!mobile">{{position.openRate}}</td>
                <td class="portHeading" *ngIf="position.lossOrGain" style="color: green"><b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="!position.lossOrGain" style="color: #EE4B2B">-<b>${{position.profitloss}}</b>
                </td>
                <td class="portHeading" *ngIf="position.negOrPos" style="color: green; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
                <td class="portHeading" *ngIf="!position.negOrPos" style="color: #EE4B2B; text-align: right;">
                  <b>{{position.netProfit}}%</b></td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left;">
                  <b>Current MTD - Gain / Loss Rate</b>
                </td>
                <td style="text-align: right;">
                  <b>Total</b>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: right;">
                  <span class="portHeading" *ngIf="netGain >= 0"
                    style="color: green; text-align: right;"><b>{{netGain}}%</b></span>
                  <span class="portHeading" *ngIf="netGain < 0"
                    style="color: #EE4B2B; text-align: right;"><b>{{netGain}}%</b></span>
                </td>
              </tr>
            </tbody>
          </div>

        </span>
      </div>
    </div>
  </div>
</div>